(function(){
    'use strict'

    angular.module('app.procesosMasivos')
    .factory('ProcesosMasivosService', ProcesosMasivosService);

    ProcesosMasivosService.$inject = ['$http', 'apiSettings', 'UserInfoService'];

    function ProcesosMasivosService($http, apiSettings, UserInfoService) {

        var api = {
            getTipos: getTipos,
            getDetalle: getDetalle,
            search: search,
            procesar: procesar,
            reversar: reversar,
            getEncabezadoProceso: getEncabezadoProceso
        };

        return api;

        function getEncabezadoProceso(procesoId){

            var url = apiSettings.apiBaseUrl + 'api/procesos-masivos/' + UserInfoService.getCompaniaId() + '/' + procesoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTipos(){

            var url = apiSettings.apiBaseUrl + 'api/procesos-masivos/tipos';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getDetalle(encabezadoId){

            var url = apiSettings.apiBaseUrl + 'api/procesos-masivos/detalle/' + UserInfoService.getCompaniaId() + '/' + encabezadoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function procesar(searchCriteria){

            if(!searchCriteria.companiaId){
                searchCriteria.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesos-masivos',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        }; 

        function reversar(proceso){

            if(!proceso.companiaId){
                proceso.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesos-masivos/reversar',  
                method: 'POST',  
                data: proceso
            });  
            return response;
        }; 

        function search(searchCriteria){

            if(!searchCriteria.companiaId){
                searchCriteria.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesos-masivos/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

    };

})();